import React from "react";
import { PageHeader } from "@/components/common";
import FaqList from "@/components/FaqList";

export default function DashboardFaq() {
  return (
    <div data-testid="dashboard-faq-page" className="max-w-3xl">
      <PageHeader
        title="Frequently asked questions"
        subtitle="Quick, practical answers to the oral-care questions care teams ask most. Read the quick answer in seconds, or expand for the detail."
      />
      <FaqList />
    </div>
  );
}
